import React from 'react';
import {activateRenewedCardConstants} from '../../../../utils/constants/activateRenewed';
import {Markdown} from '../../../../shared/markdown';
import {Controller, useFormContext} from 'react-hook-form';
import Input from '../../../../shared/formElements/input';

export const ActivateRenewedCardInputs = () => {
  const {
    control,
    formState: {errors},
  } = useFormContext();

  const {
    defaultValue,
    activationCodeSubText,
    phoneNumberSubText
  } = activateRenewedCardConstants;

  return (
    <>
      <Controller
        name="phoneNumber"
        control={control}
        defaultValue={defaultValue.phoneNumber || ''}
        render={({ field, fieldState }: any) => (
          <Input
            {...field}
            type="tel"
            label="Mobile Number*"
            fieldName="phoneNumber"
            validation={fieldState?.error?.message || ''}
            width="100%"
          />
        )}
      />
      <Markdown
        children={phoneNumberSubText}
        className="subText"
      />

      <Controller
        name="activationCode"
        control={control}
        defaultValue={defaultValue.activationCode || ''}
        render={(props) => (
          <Input
            {...(props as any)}
            type="alphanumeric"
            maxLength={9}
            label="Activation Code*"
            fieldName="activationCode"
            validation={errors?.activationCode?.message as string}
            tooltip="How to find my Unique Card ID?"
            tooltipLink="https://vaultps.zendesk.com/hc/en-au/articles/4416855429263-Where-do-I-find-my-card-EAID-"
            width="100%"
          />
        )}
      />
      <Markdown
        children={activationCodeSubText}
        className="subText"
      />
    </>
  );
};